import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { UpdateCapacityReservationConstraintsRequest } from '@cast/types-cluster-autoscaler';

import { getSelectionTemplatesQueryKey } from 'hooks/queries/autoscaler/useSelectionTemplatesQuery';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

type Variables = Omit<
  UpdateCapacityReservationConstraintsRequest,
  'organizationId'
>;

export const useUpdateNodeTemplateCapacityReservationConstraintsMutation =
  (): UseMutationResult<AxiosResponse<object>, unknown, Variables, unknown> => {
    const { currentOrganization } = useOrganizations();

    const queryClient = useQueryClient();

    return useMutation({
      mutationFn: (request: Variables) => {
        if (!currentOrganization) {
          throw new Error('Organization context is not available');
        }
        return apiClient.clusterAutoscaler.updateNodeTemplatesCapacityReservationConstraints(
          {
            organizationId: currentOrganization.id,
            updateCapacityReservationConstraintsRequest: {
              ...request,
              organizationId: currentOrganization.id,
            },
          }
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getSelectionTemplatesQueryKey(),
        });
      },
      onError: (error: unknown) => {
        notify.error(parseApiError(error));
      },
    });
  };
